import { useEffect, useRef } from 'react';
import BuenlugarNavbar from './components/BuenlugarNavbar';
import BuenlugarHero from './components/BuenlugarHero';
import AvailabilitySearchBar from '@/components/feature/AvailabilitySearchBar';
import BuenlugarAmenities from './components/BuenlugarAmenities';
import BuenlugarDescription from './components/BuenlugarDescription';
import BuenlugarGallery from './components/BuenlugarGallery';
import BuenlugarFeatures from './components/BuenlugarFeatures';
import BuenlugarLayout from './components/BuenlugarLayout';
import BuenlugarMap from './components/BuenlugarMap';
import BuenlugarRules from './components/BuenlugarRules';
import BuenlugarCTA from './components/BuenlugarCTA';
import Footer from '@/pages/home/components/Footer';
import VillaBookingSection from '@/components/feature/VillaBookingSection';

export default function VillaBuenlugar() {
  const observerRef = useRef<IntersectionObserver | null>(null);

  useEffect(() => {
    observerRef.current = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
    );

    const elements = document.querySelectorAll('.scroll-reveal');
    elements.forEach((el) => observerRef.current?.observe(el));

    return () => {
      observerRef.current?.disconnect();
    };
  }, []);

  return (
    <main>
      <BuenlugarNavbar />
      <BuenlugarHero />
      <AvailabilitySearchBar villaSlug="villa-buenlugar" />
      <VillaBookingSection villaSlug="villa-buenlugar" />
      <BuenlugarAmenities />
      <BuenlugarDescription />
      <BuenlugarGallery />
      <BuenlugarFeatures />
      <BuenlugarLayout />
      <BuenlugarMap />
      <BuenlugarRules />
      <BuenlugarCTA />
      <Footer />
    </main>
  );
}